/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import Category from "../Category.js"
import {supplier_arry} from "../../config"
import { API_URL, downloadFile } from"../../network"


// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import classnames from 'classnames';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { Link } from "react-router-dom";
import DownloadLink from "react-download-link";
import { Document, Page } from 'react-pdf';




function Index(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [delettingFile, setDeletingFile] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [curSrc, setCurSrc] = useState(null);
  const [selectQuoteModal, setSelectQuoteModal] = useState(false);
  const [quotes, setQuotes] = useState([]);
  const [selectedQuote, setsSelectedQuote] = useState(null);

  const fileRef = useRef(null);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(0.8)
  const [userRole, setUserRole] = useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    getData(props.selectedUser);
  },[props.selectedUser]);

  
  const toggleSelectQuote = () => setSelectQuoteModal(!selectQuoteModal);

  const getData = (selectedUser)=>{
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    setUserRole(role);
    if(!selectedUser && role=="admin"){
      setTableData([]); return;
    }
    axios.get(`/visuals/index?userid=${selectedUser?selectedUser:''}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        setTableData(res.data.data);
        setQuotes(res.data.quotes);
    })    
  }

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  const onChangeFile=(e)=>{
    if(e.target.files[0]){
      setSelectQuoteModal(true);
    }
  }

  const addVisual=()=>{
    if(selectedQuote){
      setSelectQuoteModal(false);
      setUploadingFile(true)
      var bodyFormData = new FormData();
      // if(fileRef.current.files[0].name.includes("'")){
      //   toast.error('File name is invalid');
      //   return
      // }
      bodyFormData.append('visual', fileRef.current.files[0]); 
      bodyFormData.append('quote_id', selectedQuote)   ;
      axios.post(`/visuals/add?userid=${props.selectedUser}`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Your visual has been added");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
      fileRef.current.value = null
    }
  }
  
  const cancelVisual=()=>{
    setSelectQuoteModal(false);
    if(fileRef.current)
      fileRef.current.value = null
  }

  const deleteRow=(id)=>{        
    setDeletingFile(true)
    var bodyFormData = new FormData();   
    axios.post(`/visuals/delete/${id}`, bodyFormData).then(res => {
      const result = res.data;        
      setDeletingFile(false)
      if(result.status == "success"){        
        toast.success("Your visual has been deleted");
        getData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {     
      setDeletingFile(false)
      toast.error('Something was wrong. Try again');
    })
  }
  
  var extension = null;
  if(curSrc)
    extension = curSrc.split('.').pop();
  var overlayText = "";
  if(delettingFile)
    overlayText = "Deleting Visual...";
  if(uploadingFile)
    overlayText = "Uploading Visual...";
  return (
    <>    
    <Row className="mt-4">
        <Col md="12">
        </Col>
        <Col md="6">
          <div>
          {userRole =="admin" && <div id="visual-upload-container" className="">
            <Button onClick={()=>{fileRef.current.click()}} className="rounded-0 pr-6" color="primary" type="button">
              Upload
            </Button>
              <input type="file" ref={fileRef} style={{display:'none'}} onChange={(e)=>onChangeFile(e)}/>
            <label className="help-icon" style={{margin:"9px 0 0 11px"}} href="#" id="visual-upload" >i</label>
            {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
            <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="visual-upload" toggle={toggletooltip}>
              Visuals from previous jobs will be saved here.<br/>
              You can view these and be confident in knowing what you are ordering.
            </Tooltip>
            </div>
          }
           
          </div>
          <Table className="mt-3" striped >
            <thead>
              <tr>
                <th></th>
                <th></th>
                <th>No.</th>
                <th>Name</th>
                <th>Date</th>
              </tr>
            </thead>            
            <tbody>
              {
                tableData.map((row, index)=>{
                  return (
                    <tr>
                      <td width="50px" className="pl-2 pr-2" textCenter scope="row">
                        <i className="fa fa-times"
                          style={{cursor:'pointer'}}
                          onClick={() => {
                            deleteRow(row['id'])
                            // setCurSrc(`${API_URL}${row['file_path']}`)
                            // const newState = [...state];
                            // newState[ind].splice(index, 1);
                            // updateState(
                            //   newState.filter(group => group.length)
                            // );
                          }}
                        ></i>  
                      </td>
                      <td width="50px" className="pl-2 pr-2" scope="row">
                        <span style={{cursor:"pointer"}} onClick={()=>{setCurSrc(`${API_URL}${row['file_path']}`)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
                      </td>
                      <td>
                        #{row['quote_id']}
                      </td>
                      <td className="pl-2 pr-2" scope="row">
                        {row['file_name']}
                      </td>
                      <td>
                        {row['created_at']}
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </Table>
        </Col>
        <Col md="6">
          <div className="resource-preview-container">
            <div className="resource-preview">
            {extension && ( extension.toLowerCase().includes("jpg") || extension.toLowerCase().includes("png") || extension.toLowerCase().includes("jpeg") || extension.toLowerCase().includes("gif") ) &&
                <InnerImageZoom src={curSrc} zoomSrc={curSrc} /> 
              }
              {extension && ( extension.includes("pdf")) &&
              <div>
                <Document file={curSrc} onLoadSuccess={onDocumentLoadSuccess}>
                  <Page scale={pdfScale} pageNumber={pageNumber} />
                </Document>
              </div>
              }
            </div>
            {curSrc &&extension && ( extension.includes("pdf")) &&
            <div className="d-flex justify-content-between">
              <a href={curSrc} download target="_blank" ><i className="fa fa-folder-open"></i></a>
              <div>
                <i className="fa fa-search-minus mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfScale(pdfScale*0.8)}}></i>
                <i className="fa fa-search-plus mr-3" style={{cursor:'pointer'}} onClick={()=>{ setPdfScale(pdfScale*1.2)}}></i>
                <i className="fa fa-chevron-left mr-3" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber>1) setPageNumber(pageNumber-1)}}></i>
                <span className="mr-3" style={{fontSize:14}}>Page {pageNumber} of {numPages}</span>
                <i className="fa fa-chevron-right" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber<numPages) setPageNumber(pageNumber+1)}} ></i>
              </div>
            </div>
            }
          </div>
        </Col>
      </Row>
      <LoadingOverlay
        active={uploadingFile||delettingFile}
        styles={{
            overlay: (base) => ({
            ...base,
            fontSize:'18px',
            color: 'rgb(5, 37, 51)',
            background: 'rgb(60 60 60 / 48%)',
            position:'fixed',
            zIndex:1000000000
            })
        }}
        spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
        // spinner
        // text='Loading ...'
        >
      </LoadingOverlay>
      <Modal isOpen={selectQuoteModal} toggle={toggleSelectQuote} size="md">
          <ModalHeader toggle={toggleSelectQuote}>
            <h3 className="h4 font-weight-bold mb-0">
              Select a Quote
            </h3>
          </ModalHeader>
          <ModalBody>
                <FormGroup>
                  <Input type="select" name="quote" onChange={(e)=>setsSelectedQuote(e.target.value)}>
                    <option value={null}></option>   
                    {
                      quotes.map((quote)=>(                                
                        <option value={quote.id}>#{quote.id}</option>
                      ))
                    }
                  </Input>           
                </FormGroup>
                <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                  <Button color="primary" onClick={()=>addVisual()}>Add</Button>{' '}
                  <Button color="secondary" onClick={()=>cancelVisual()}>Cancel</Button>
                </div>
          </ModalBody>       
        </Modal>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
